<template>
  <brand-list :type="1"></brand-list>
</template>

<script>

import BrandList from "@view/components/brand-list.vue";

export default {
  name: "brand",
  components: {BrandList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
